import { render, staticRenderFns } from "./ViewHeights.vue?vue&type=template&id=4c38f191&scoped=true&"
import script from "./ViewHeights.vue?vue&type=script&lang=js&"
export * from "./ViewHeights.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c38f191",
  null
  
)

export default component.exports